import { Paginator } from '@features/_shared/components/Paginator';
import { TextField } from '@features/_shared/components/TextField';
import { FaqManager } from '@managers/faq.manager';
import { QueueKeyType, QueueManager } from '@managers/queue.manager';
import { TranslatorManager } from '@managers/TranslatorManager';
import React, { useEffect, useState } from 'react';
import { Faq, Topic } from 'src/api';
import './styles/topic.filter.style.scss';

export interface ITopicFilterComponentProps {
    onTopicClick(faqs: Array<Faq>): Promise<void>;
}

export const TopicFilterComponent: React.FC<ITopicFilterComponentProps> = ({ onTopicClick }) => {
    const faqManager = FaqManager.getInstance();
    const queueManager = QueueManager.getInstance();
    const translatorManager = TranslatorManager.getInstance();
    const [activeTopic, setActiveTopic] = useState<string | undefined>(undefined);
    const [entriesNumber, setEntriesNumber] = useState<number>(3);
    const [topicsList, setTopicsList] = useState<Array<Topic>>([]);
    const [topicsListFiltered, setTopicsListFiltered] = useState<Array<Topic>>([]);
    const [currentPage, setCurrentPage] = useState<number>(0);

    useEffect(() => {
        const fetchDataOnLoad = async () => {
            const topics = (await queueManager.queue(QueueKeyType.DEFAULT, faqManager.getTopicList())).topics;
            topics ? setTopicsList(topics) : setTopicsList([]);
            topics ? setTopicsListFiltered(topics) : setTopicsListFiltered([]);
            topics && setActiveTopic(topics[0]?.term_id);
            topics && handleOnTopicClick(topics[0]?.term_id);
        };
        fetchDataOnLoad();
    }, []);

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        var completeList = topicsList;
        var filteredList = topicsList;
        filteredList = e.target.value !== '' ? topicsList.filter((item: any) => item.name.toLowerCase().includes(e.target.value.toLowerCase())) : completeList;
        setTopicsListFiltered(filteredList);
    };

    const handleEntriesChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setEntriesNumber(parseInt(e.target.value));
    };

    const handleOnTopicClick = async (topicId?: string) => {
        const response = await queueManager.queue(QueueKeyType.DEFAULT, FaqManager.getInstance().getFaqList(topicId as string));
        setActiveTopic(topicId);
        response.faqs && onTopicClick?.(response.faqs);
    };

    const handlePaginationChange = async (page: number, size: number, total: number) => {
        setCurrentPage(page);
    };

    return (
        <div className='col-lg-4 col-sm-12'>
            <div className='d-flex m-2' style={{ alignItems: 'baseline', gap: '22px', fontSize: 16 }}>
                <span>{translatorManager.get('topic.seach.show.label')}</span>
                <div>
                    <div className='select-wrapper'>
                        <select className='select-container' onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleEntriesChange(e)}>
                            <option value={10} selected>
                                10
                            </option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>
                </div>
                <span>{translatorManager.get('topic.seach.entries.label')}</span>
            </div>

            <div className='d-flex m-2' style={{ alignItems: 'baseline', gap: '10px', fontSize: 16 }}>
                <span>{translatorManager.get('topic.seach.search.label')}</span>
                <div>
                    <TextField key='search' className='form-control' onChange={(e: any) => handleFilterChange(e)} name='search' />
                </div>
            </div>

            <div className='m-2'>
                <h6>{translatorManager.get('topic.title.label')}</h6>
            </div>
            {topicsListFiltered.slice(currentPage * entriesNumber, currentPage * entriesNumber + entriesNumber).map((item: Topic) => {
                return (
                    <div
                        key={item.term_id}
                        style={{ fontSize: 16 }}
                        onClick={() => handleOnTopicClick(item.term_id)}
                        className={`topic-container ${activeTopic === item.term_id ? 'selected-topic' : 'unselected-topic'}`}>
                        {item.name}
                    </div>
                );
            })}

            <div style={{ marginTop: '5%', fontSize: 15 }}>
                <span>{`Showing ${Math.ceil(topicsList.length / entriesNumber) * currentPage + 1} to ${
                    Math.ceil(topicsList.length / entriesNumber) * currentPage + entriesNumber < topicsList.length
                        ? Math.ceil(topicsList.length / entriesNumber) * currentPage + entriesNumber
                        : topicsList.length
                } of ${topicsList.length} entries`}</span>
            </div>

            <div style={{ fontSize: 15 }}>
                <Paginator page={currentPage} size={entriesNumber} total={topicsList.length as number} onChange={handlePaginationChange} />
            </div>
        </div>
    );
};
